import clsx from 'clsx/lite'
import React from 'react'

type LoaderProps = {
  className?: string
}

const Loader: React.FC<LoaderProps> = ({ className, ...props }) => (
  <span
    role="progressbar"
    className={clsx(
      'relative inline-block h-12 w-12',
      'before:h-12 before:w-12',
      'after:h-12 after:w-12',
      'before:absolute before:rounded-full',
      'before:left-0 before:top-0 before:animate-loaderPulseIn before:bg-green-500',
      'after:absolute after:rounded-full',
      'after:animate-loaderPulseOut after:bg-gray-300',
      className
    )}
    {...props}
  />
)

export default Loader
